module.exports = __webpack_public_path__ + "static/media/monument.f9c15aac.jpg";